const roles = {
  DIRETORIA: 1,
  GERENCIA: 2,
  COMERCIAL: 3,
  EXTERNOS: 4,
  OPERACIONAL: 5,
  SEGURO: 6,
  INTELIGENCIA: 7,
  PROSPECTING: 8,
  FINANCEIRO: 9,
  MARKETING: 10,
  GRUPO_DE_TESTE_CADASTRO: 21,
  TESTE_TI: 27
};

export default roles;